import { useState, useEffect } from "react";

import {
  collection,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
} from "firebase/firestore";
import { getDb, getRef } from "lib/firebase";
import { convertDate } from "lib/utils";

import { IndexArticle, CurrentUser } from "lib/type";

type Props = {
  author: CurrentUser;
  articles: IndexArticle[];
};

export const useClientFetchUser = (props: Props, userUid = "") => {
  const [author, setAuthor] = useState(props.author);
  const [articles, setArticles] = useState(props.articles);
  useEffect(() => {
    const isAuthor = props.author && userUid === props.author.uid;
    if (!isAuthor) return;
    const loadUser = async () => {
      const userRef = getRef("users", userUid);
      const userDoc = await getDoc(userRef).catch((err) => {
        console.log(err);
        alert("ユーザー情報の取得に失敗しました。");
        return null;
      });
      if (!userDoc || !userDoc.exists()) return;
      const userData = userDoc.data() as CurrentUser;
      setAuthor(userData);
    };
    loadUser();
  }, [props.author, userUid]);

  useEffect(() => {
    const isAuthor = props.author && userUid === props.author.uid;
    if (!isAuthor) return;
    const loadArticles = async () => {
      const articlesRef = collection(
        getDb(),
        `users/${userUid}/publicArticles`
      );
      const q = query(articlesRef, orderBy("createdAt", "desc"), limit(10));
      const articleDocs = await getDocs(q).catch((err) => {
        console.log(err);
        alert("記事情報の取得に失敗しました。");
        return null;
      });
      if (!articleDocs || articleDocs.empty) return;
      const articleDatas = await Promise.all(
        articleDocs.docs.map((articleDoc) => {
          const articleData = articleDoc.data();
          const { title, thumb, color, createdAt, updateAt, tags, likeCount } =
            articleData;
          const crateDate = convertDate(createdAt);
          const updateDate = convertDate(updateAt);
          return {
            articleID: articleDoc.id,
            title: title,
            thumb: thumb,
            color: color,
            createdAt: crateDate,
            updateAt: updateDate,
            tags: tags,
            likeCount: likeCount,
          };
        })
      );
      setArticles(articleDatas);
    };
    loadArticles();
  }, [props.author, userUid]);

  return { author, articles };
};
